import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

import * as layerOps from '../../../api/Layers/layer-operations';
import { LAYER_TYPES } from '../../../api/Layers/Layers';

import DoubleRangeSlider from '../DoubleRangeSlider';

const LayerZoomField = ({ layer, layerType }) => {
  if (layerType === LAYER_TYPES.THEMATIC) return '';

  const [maxZoom, changeMaxZoom] = useState(layerOps.getMaxZoom(layer));
  const [minZoom, changeMinZoom] = useState(layerOps.getMinZoom(layer));

  return (
    <Form.Group>
      <Form.Label>Zoom Levels</Form.Label>
      <DoubleRangeSlider
        domain={[0, 24]}
        maxValue={maxZoom}
        minValue={minZoom}
        changeMaxValue={changeMaxZoom}
        changeMinValue={changeMinZoom}
      />
      <Form.Control name="minZoom" value={minZoom} style={{ display: 'none' }} readOnly />
      <Form.Control name="maxZoom" value={maxZoom} style={{ display: 'none' }} readOnly />
    </Form.Group>
  );
};

LayerZoomField.propTypes = {
  layer: PropTypes.object.isRequired,
  layerType: PropTypes.string.isRequired
};

export default LayerZoomField;
